/**
 * Nolana theme — product recommendations loader.
 * <product-recommendations data-url="…"> fetches its own section through the Section
 * Rendering API (product recommendations endpoint) once it is near the viewport and swaps in
 * the rendered row. Elements without data-url (manual collection) are left untouched.
 */
(function () {
  "use strict";

  if (window.customElements.get("product-recommendations")) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute("data-url");
      if (!url || this.dataset.loaded === "true") return;
      var load = function () {
        this.dataset.loaded = "true";
        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var fresh = doc.querySelector("product-recommendations");
              if (fresh && fresh.innerHTML.trim()) {
                this.innerHTML = fresh.innerHTML;
                if (window.Nolana && typeof window.Nolana.initReveal === "function") window.Nolana.initReveal(this);
              }
            }.bind(this)
          )
          .catch(function () {});
      }.bind(this);

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            load();
          },
          { rootMargin: "0px 0px 400px 0px" }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  window.customElements.define("product-recommendations", ProductRecommendations);
})();
